import { combineReducers } from "redux";

import user from "./reducers/user";
import uiDataReducer from "./reducers/uiData";
import nav from "./reducers/nav";
import stickyNav from "./reducers/stickyNavReducer";
import glb from "./reducers/glb";
import apiProgressList from "./reducers/apiProgressList";
import apiCancelSource from "./reducers/apiCancelSource";
import appMessage from "./reducers/appMessage";
import userAccount from "./reducers/userAccount";
import appStatesList from "./reducers/appStatesList";
import userDisclosures from "./reducers/userDisclosures";
import appCitiesList from "./reducers/appCitiesList";
import userCases from "./reducers/userCases";
import userCaseCharges from "./reducers/userCaseCharges";
import dppaAndState from "./reducers/dppaAndState";

export default combineReducers({
  user,
  glb,
  nav,
  stickyNav,
  progressList: apiProgressList,
  apiCancelSource,
  uiData: uiDataReducer,
  appMessage,
  userAccount,
  appStatesList,
  userDisclosures,
  appCitiesList,
  userCases,
  userCaseCharges,
  dppaAndState,
});



// WEBPACK FOOTER //
// ./src/rootReducer.js